import { render, staticRenderFns } from "./ManagementConfiguration.vue?vue&type=template&id=5c4b3f2c&scoped=true"
import script from "./ManagementConfiguration.vue?vue&type=script&lang=js"
export * from "./ManagementConfiguration.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ManagementConfiguration.vue?vue&type=style&index=1&id=5c4b3f2c&prod&scoped=true&lang=scss"
import style2 from "./ManagementConfiguration.vue?vue&type=style&index=2&id=5c4b3f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b3f2c",
  null
  
)

export default component.exports